import { Box } from "@material-ui/core";
import React from "react";
import Section from "@atoms/Section/Section";
import Title from "@atoms/Title/Title";
import Icon from "@atoms/Icon/Icon";
import GatsbyResponsiveImage from "@atoms/GatsbyResponsiveImage/GatsbyResponsiveImage";
import { ImageRenderType } from "@atoms/ResponsiveSharpImg/ResponsiveSharpImg";
import "./ChapterEntries.scss";
import { IconArrowForward } from "../../atoms/Icon/list";
import { IconShare } from "@atoms/Icon/list";
import { useTracking } from "../../hooks";
import { AnalyticsEventType } from "../../context/TrackingProvider";

const ChapterEntries = ({ list }) => {
	const { track } = useTracking();

	return (
		<Section container="extraLarge" className="ChapterEntries">
			<div className="ChapterEntries--container">
				{list.map((item: any, index: number) => {
					const isLastItem = index === list?.length - 1;
					const desktopImage = item.images.find(
						(item: any) => item.media === "desktop",
					);
					const mobileImage = item.images.find(
						(item: any) => item.media === "mobile",
					);
					return (
						<a
							target={isLastItem ? "_blank" : "_self"}
							rel={isLastItem ? "noreferrer" : ""}
							href={item.url}
							key={`ChapterEntries_${index}`}
							className="ChapterEntries--item"
							onClick={() => {
								track({
									eventType: AnalyticsEventType.GButtonClick,
									data: {
										buttonName: `${item.title.toLowerCase().replace(/ /g, "_")}_button`,
										sourceUrl: window.location.pathname,
										targetUrl: item.url,
									},
								});
							}}
						>
							<div className="ChapterEntries--img">
								<div className="green-gradient-beige-background" />
								<GatsbyResponsiveImage
									url={desktopImage?.src?.url}
									mobileUrl={mobileImage?.src?.url}
									urlSharp={desktopImage?.src?.urlSharp}
									mobileSharpImage={mobileImage?.src?.urlSharp}
									altText={item.title}
									type={ImageRenderType.Img}
								/>
							</div>
							<Box
								display="flex"
								alignItems="flex-end"
								justifyContent="space-between"
								className="ChapterEntries--item-content"
							>
								<Title theme="white" size="l" noMargin>
									{item.title}
								</Title>
								<Icon
									size="xs"
									theme="white"
									icon={isLastItem ? <IconShare /> : <IconArrowForward />}
								/>
							</Box>
						</a>
					);
				})}
			</div>
		</Section>
	);
};

export default ChapterEntries;
